import { z } from "zod";

/**
 * Routes which mailbox an AR email (statement or invoice) is sent through.
 *
 * - `configured`: use the AR module config's outbox (Send-As alias paired with
 *   the configured mailbox UPN). Default when omitted.
 * - `user_mailbox`: send directly from a specific user UPN, with no alias.
 *   The visible From is the same as the sending mailbox.
 */
export const sendFromOverrideSchema = z.discriminatedUnion("mode", [
  z.object({ mode: z.literal("configured") }),
  z.object({
    mode: z.literal("user_mailbox"),
    mailboxUpn: z.string().email(),
  }),
]);

export type SendFromOverride = z.infer<typeof sendFromOverrideSchema>;
